module.exports = __webpack_public_path__ + "img/coronapanel.com.8d7933b7.png";